var _rect, _rect2, _rect3, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoLogs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 41.3892,
    width: 42,
    height: 56,
    rx: 4,
    transform: "rotate(-15 18 41.3892)",
    fill: "white",
    stroke: "#DEDEDE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "8 8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 61.4939,
    y: 30.5188,
    width: 42,
    height: 56,
    rx: 4,
    transform: "rotate(15 61.4939 30.5188)",
    fill: "white",
    stroke: "#DEDEDE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "8 8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 36.5314,
    y: 24,
    width: 48,
    height: 64,
    rx: 4,
    fill: "white",
    stroke: "#C9C9C9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "8 8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5314,
    cy: 56,
    r: 12,
    fill: "#EDEDED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.4017 56.9163L59.6152 56.9163L59.6152 60.1298C59.6152 60.3815 59.7172 60.6003 59.889 60.7722C60.0608 60.944 60.2797 61.046 60.5314 61.046C60.783 61.046 61.0019 60.944 61.1737 60.7722C61.3455 60.6003 61.4476 60.3815 61.4476 60.1298L61.4476 56.9163L64.6611 56.9163C64.9127 56.9163 65.1316 56.8143 65.3034 56.6424C65.4753 56.4706 65.5773 56.2518 65.5773 56.0001C65.5773 55.7484 65.4753 55.5296 65.3034 55.3578C65.1316 55.1859 64.9127 55.0839 64.6611 55.0839L61.4476 55.0839L61.4476 51.8704C61.4476 51.6187 61.3455 51.3999 61.1737 51.228C61.0019 51.0562 60.783 50.9542 60.5314 50.9542C60.2797 50.9542 60.0608 51.0562 59.889 51.228C59.7172 51.3999 59.6152 51.6187 59.6152 51.8704L59.6152 55.0839L56.4017 55.0839C56.15 55.0839 55.9311 55.1859 55.7593 55.3578C55.5875 55.5296 55.4854 55.7484 55.4854 56.0001C55.4854 56.2518 55.5875 56.4706 55.7593 56.6424C55.9311 56.8143 56.15 56.9163 56.4017 56.9163Z",
    fill: "#C9C9C9",
    stroke: "#C9C9C9",
    strokeWidth: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoLogs);
export default __webpack_public_path__ + "static/media/no-logs.99810775457f5eac2163d6125b3ecba2.svg";
export { ForwardRef as ReactComponent };